import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postLicencia } from "../../../redux/actions";
import ErrorModal from "../../../components/modals/errorModal";
import Button from "../../../components/button";
import { formatFechaHora } from "../../../utils/formatDate";

const sectionClass =
  "bg-white rounded-lg border border-[#61ABCF] divide-y divide-[#61ABCF]";

const rowClass = "grid grid-cols-2 gap-5 px-4 py-2";

const labelClass = "text-sm/6 font-medium text-gray-900";

const valueClass = "mt-1 sm:mt-0 text-sm/6 text-gray-700";

const titleClass = "text-sm/6 font-bold text-[#036395] font-inter";

function InfoRow({ label, value }) {
  return (
    <div className={rowClass}>
      <dt className={labelClass}>{label}</dt>
      <dd className={valueClass}>{value || "-"}</dd>
    </div>
  );
}

function SectionTitle({ children }) {
  return (
    <div className={rowClass}>
      <dt className={titleClass}>{children}</dt>
      <dd />
    </div>
  );
}

function ConfirmarDatosLicencia({
  closeConfirmarDatosLicencia,
  openSuccessModal,
}) {
  const dispatch = useDispatch();

  const dataIngresoLicencia = useSelector(
    (state) => state.dataIngresoLicencia
  );
  const fotoLicencia = useSelector((state) => state.fotoLicencia);
  const tipoCurrentUser = useSelector((state) => state.tipoCurrentUser);

  const [loading, setLoading] = useState(false);

  const [errorModal, setErrorModal] = useState({
    show: false,
    message: "",
  });

  const openErrorModal = (message) => {
    setErrorModal({
      show: true,
      message,
    });
  };

  const closeErrorModal = () => {
    setErrorModal({
      show: false,
      message: "",
    });
  };

  const data = {
    ...dataIngresoLicencia,
    foto: fotoLicencia || null,
  };

  const handleConfirm = async () => {
    setLoading(true);

    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (key === "foto") {
        if (value) formData.append("foto", value);
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await dispatch(postLicencia(formData));
      if (response) {
        closeConfirmarDatosLicencia();
        openSuccessModal();
      }
    } catch (error) {
      console.error("Error:", error);

      const serverErrorMessage =
        error.response?.data?.error ||
        "Error inesperado al registrar la licencia.";

      openErrorModal(serverErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  const disabled = loading || tipoCurrentUser === "viewer";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
      onClick={closeConfirmarDatosLicencia}
    >
      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}
      <div
        className="relative flex flex-col gap-4 rounded-lg border bg-[#F5FAFF] p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={closeConfirmarDatosLicencia}
          className="absolute right-2 top-1 text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>

        <div className={sectionClass}>
          <SectionTitle>Verificar la información</SectionTitle>

          <InfoRow
            label="Apellido y nombres"
            value={dataIngresoLicencia?.nombre}
          />

          <InfoRow
            label="DNI"
            value={dataIngresoLicencia?.dni}
          />

          <InfoRow
            label="Número"
            value={dataIngresoLicencia?.numero}
          />

          <InfoRow
            label="Fecha y Hora"
            value={formatFechaHora(dataIngresoLicencia?.fecha_hora, "-")}
          />

          <InfoRow
            label="Observaciones"
            value={dataIngresoLicencia?.observaciones}
          />
        </div>

        <div className="inline-flex w-full gap-4">
          <Button
            variant="secondary"
            fullWidth
            onClick={closeConfirmarDatosLicencia}
            className="h-[45px]"
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            fullWidth
            loading={loading}
            disabled={disabled}
            onClick={handleConfirm}
            className="h-[45px]"
          >
            Ingresar licencia
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmarDatosLicencia;